import React from 'react';

interface PanelHeadingProps {
  children: React.ReactNode;
  variant?: 'primary' | 'default';
  className?: string;
}

export const PanelHeading: React.FC<PanelHeadingProps> = ({ 
  children, 
  variant = 'default',
  className = ''
}) => {
  const baseClasses = "text-[19px] font-bold mb-[10px]";
  const colorClass = variant === 'primary' ? 'text-[#4342FF]' : 'text-[#252528]';
  
  return (
    <h3 
      className={`${baseClasses} ${colorClass} ${className}`}
      style={{ fontFamily: 'Open Sans, sans-serif' }}
    >
      {children}
    </h3>
  );
};